import React, { FC, useEffect, useState } from 'react'

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../../../../../../ui/accordion'
import customImageComponent from '../../../../../../../common/CustomImageComponent'
import { getUserFullName } from '../../../../../../../../helpers/helpers'
import { UserRequiredFieldsCard } from '../../../../cards/UserRequiredFieldsCard/UserRequiredFieldsCard'
import { UserProfileCard } from '../../../../cards/UserProfileCard/UserProfileCard'
import { RidingDetailsCard } from '../../../../cards/RidingDetailsCard/RidingDetailsCard'
import { UserMembershipsCard } from '../../../../cards/UserMembershipsCard/UserMembershipsCard'

import {
  getUserRequiredFields,
  hasInvalidRequiredField,
} from '../../../../../../../../helpers/requiredFields'
import { cn } from '../../../../../../../../lib/utils'

import { IRiderTeamMemberInterface } from '../../../../../../../../models/rider-team-member/riderTeamMember.interface'
import { IUserInterface } from '../../../../../../../../models/users/user.interface'

interface TeamTabItemProps {
  index: number
  type?: 'overview' | 'registrar'
  teamMember: IRiderTeamMemberInterface
  user: IUserInterface
  setUser: (value: IUserInterface) => void
  eventRequiredUserFields?: string[]
}
export const TeamTabItem: FC<TeamTabItemProps> = ({
  index,
  type,
  teamMember,
  user,
  setUser,
  eventRequiredUserFields,
}) => {
  const [issues, setIssues] = useState(0)

  useEffect(() => {
    const fields = getUserRequiredFields({ user, eventRequiredUserFields })
    const fieldsFiltered = fields.filter((field) => !hasInvalidRequiredField(field))
    setIssues(fields.length - fieldsFiltered.length || 0)
  }, [eventRequiredUserFields, user])

  const showOnlyErrors = () => {
    return type === 'overview' ? issues : true
  }

  return showOnlyErrors() ? (
    <Accordion className="border-t-black/10 border-t" type="single" collapsible>
      <AccordionItem value={`item-${index}`}>
        <AccordionTrigger
          className={cn(
            type === 'overview' && 'pointer-events-none [&_.accordion-arrow-icon]:hidden'
          )}
        >
          <div className="flex items-center gap-3">
            <div className="w-[45px] h-[45px] rounded-md overflow-hidden border border-black/10">
              {customImageComponent(
                user.userProfilePicture,
                getUserFullName(user),
                'w-full h-full object-cover'
              )}
            </div>
            <div>
              <h5 className="text-sm text-black">{getUserFullName(user)}</h5>
              <p className="text-xs text-black/50 mt-1">
                {teamMember.teamMemberRole}
                {type !== 'overview' &&
                  (issues > 0 ? `, ${issues} issue${issues > 1 ? 's' : ''}` : ', No issues')}
              </p>
            </div>
          </div>
          {type === 'overview' && (
            <div className="font-normal rounded-full py-1 px-3 text-SeabiscuitRedThemeColor bg-SeabiscuitRedThemeColor/5">
              {issues} issue{issues > 1 ? 's' : ''}
            </div>
          )}
        </AccordionTrigger>
        <AccordionContent
          className={cn(
            'grid gap-5',
            type === 'registrar' ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2'
          )}
        >
          <div className="flex flex-col gap-5">
            <UserRequiredFieldsCard
              user={user}
              setUser={setUser}
              eventRequiredUserFields={eventRequiredUserFields}
              isEditable={true}
            />
            <UserProfileCard user={user} />
          </div>
          <div className="flex flex-col gap-5">
            <RidingDetailsCard user={user} setUser={setUser} isEditable={true} />
            <UserMembershipsCard user={user} setUser={setUser} isEditable={true} />
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  ) : null
}
